import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { UserPlus, CalendarPlus, GraduationCap, CreditCard, Zap, CalendarDays } from "lucide-react";
import { OwnerDialog } from "@/components/dialogs/OwnerDialog";
import { DogDialog } from "@/components/dialogs/DogDialog";
import { CompositePrestationDialog } from "@/components/dialogs/CompositePrestationDialog";
import { PaymentDialog } from "@/components/dialogs/PaymentDialog";
import { QuickAppointmentDialog } from "@/components/dialogs/QuickAppointmentDialog";
import { useOnlineGuard } from "@/pwa/useOnlineGuard";

export const QuickActions = ({ onChange, className = "" }) => {
  const [owner, setOwner] = useState(false);
  const [prest, setPrest] = useState(false);
  const [lezione, setLezione] = useState(false);
  const [pay, setPay] = useState(false);
  const [quick, setQuick] = useState(false);
  const [dogOpen, setDogOpen] = useState(false);
  const [newDogOwner, setNewDogOwner] = useState("");
  const { guard } = useOnlineGuard();
  const nav = useNavigate();
  const done = () => onChange?.();

  const items = [
    { key: "quick", label: "Appuntamento rapido", icon: Zap, onClick: guard(() => setQuick(true)), testid: "qa-quick-appointment" },
    { key: "prest", label: "Nuova prestazione", icon: CalendarPlus, onClick: guard(() => setPrest(true)), testid: "qa-new-prestazione" },
    { key: "lez", label: "Registra lezione", icon: GraduationCap, onClick: guard(() => setLezione(true)), testid: "qa-new-lezione" },
    { key: "pay", label: "Registra pagamento", icon: CreditCard, onClick: guard(() => setPay(true)), testid: "qa-new-payment" },
    { key: "cli", label: "Nuovo cliente/cane", icon: UserPlus, onClick: guard(() => setOwner(true)), testid: "qa-new-owner" },
    { key: "agenda", label: "Agenda", icon: CalendarDays, onClick: () => nav("/agenda"), testid: "qa-open-agenda" },
  ];

  return (
    <>
      <div className={`grid grid-cols-2 lg:grid-cols-6 gap-3 ${className}`}>
        {items.map((it) => (
          <Button key={it.key} data-testid={it.testid} onClick={it.onClick}
            variant={it.key === "quick" ? "default" : "outline"}
            className="h-16 flex-col gap-1 rounded-2xl text-sm font-semibold shadow-sm whitespace-normal text-center leading-tight px-1">
            <it.icon className="h-5 w-5" />
            {it.label}
          </Button>
        ))}
      </div>
      <QuickAppointmentDialog open={quick} onOpenChange={setQuick} onSaved={done} />
      <OwnerDialog open={owner} onOpenChange={setOwner} onSaved={done} onCreatedAddDog={(o) => { setNewDogOwner(o.id); setTimeout(() => setDogOpen(true), 220); }} />
      <DogDialog open={dogOpen} onOpenChange={(v) => { setDogOpen(v); if (!v) setNewDogOwner(""); }} fixedOwnerId={newDogOwner || undefined} onSaved={done} />
      <CompositePrestationDialog open={prest} onOpenChange={setPrest} mode="prestazione" onSaved={done} />
      <CompositePrestationDialog open={lezione} onOpenChange={setLezione} mode="lezione" onSaved={done} />
      <PaymentDialog open={pay} onOpenChange={setPay} onSaved={done} />
    </>
  );
};
